var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDefault28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 22.1666H10.5001V16.3333C10.5001 16.0028 10.6119 15.7257 10.8355 15.5021C11.0591 15.2785 11.3362 15.1666 11.6667 15.1666H16.3334C16.664 15.1666 16.9411 15.2785 17.1647 15.5021C17.3883 15.7257 17.5001 16.0028 17.5001 16.3333V22.1666H21.0001V11.6666L14.0001 6.41665L7.00008 11.6666V22.1666ZM4.66675 22.1666V11.6666C4.66675 11.2972 4.74939 10.9472 4.91466 10.6166C5.07994 10.2861 5.30841 10.0139 5.60008 9.79998L12.6001 4.54998C13.0084 4.23887 13.4751 4.08331 14.0001 4.08331C14.5251 4.08331 14.9917 4.23887 15.4001 4.54998L22.4001 9.79998C22.6917 10.0139 22.9202 10.2861 23.0855 10.6166C23.2508 10.9472 23.3334 11.2972 23.3334 11.6666V22.1666C23.3334 22.8083 23.1049 23.3576 22.648 23.8146C22.1911 24.2715 21.6417 24.5 21.0001 24.5H16.3334C16.0029 24.5 15.7258 24.3882 15.5022 24.1646C15.2786 23.9409 15.1667 23.6639 15.1667 23.3333V17.5H12.8334V23.3333C12.8334 23.6639 12.7216 23.9409 12.498 24.1646C12.2744 24.3882 11.9973 24.5 11.6667 24.5H7.00008C6.35841 24.5 5.80911 24.2715 5.35216 23.8146C4.89522 23.3576 4.66675 22.8083 4.66675 22.1666Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefault28);
export default __webpack_public_path__ + "static/media/home_default_28.4cab65bebdd5ad054e3b52e323f1a172.svg";
export { ForwardRef as ReactComponent };